import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { PropertiesCard } from '../../../../components/Cards/PropertiesCard';
import './DeleteTypeSeriesDialog.css';


const DeleteAircraftDialog = ({ aircraft, onClose, onDelete, isAircraft}) => {
  const computedPart = useMemo(() => ({
    'Tail Number': aircraft?.tailNumber,
    'Registation Number': aircraft?.registrationNumber,
    'AC Serial Number': aircraft?.serialNumber,
    'Line Number': aircraft?.lineNumber
  
  }), [aircraft]);

  const deleteHandler = (e) => {
    onClose(e);
    onDelete(e);
  }

  return (<div className='delete-aircraft-dialog-component'>
    <div className='header'>
      <span>Are you sure you want to delete this Aircraft?</span>
      {/* <button className='outlined icon mid-size' onClick={onClose}>
        <i className='icon-cross'></i>
      </button> */}

    </div>
    <PropertiesCard singleCard object={computedPart} className='grey'></PropertiesCard>
    <div className='buttons'>
      <button className='filled mid-size' onClick={onClose}>Cancel</button>
      <button className='filled mid-size danger' onClick={deleteHandler}>Delete</button>
    </div>
  </div>)
}


export default DeleteAircraftDialog;